import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { FileText, AlertTriangle, Scale, Zap, Info, HelpCircle } from 'lucide-react';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar />
      
      <main className="container mx-auto px-6 pt-32 pb-24 max-w-4xl">
        <div className="bg-white rounded-[2rem] shadow-xl shadow-blue-900/5 p-8 md:p-16 border border-slate-200">
          <div className="flex items-center gap-4 mb-8">
            <div className="w-12 h-12 bg-blue-100 rounded-2xl flex items-center justify-center text-blue-600">
              <FileText className="w-6 h-6" />
            </div>
            <div>
              <h1 className="text-3xl md:text-4xl font-black text-slate-900 tracking-tight">Terms of Service</h1>
              <p className="text-slate-500 font-medium">Last Updated: April 13, 2026</p>
            </div>
          </div>

          <div className="prose prose-slate max-w-none">
            <section className="mb-12">
              <div className="flex items-center gap-3 mb-4">
                <Info className="w-5 h-5 text-blue-600" />
                <h2 className="text-xl font-bold text-slate-900 m-0">1. Acceptance of Terms</h2>
              </div>
              <p className="text-slate-600 leading-relaxed">
                By accessing or using DevelopmentAnalyzer, you agree to be bound by these Terms of Service. If you do not agree, you must immediately cease all use of our services.
              </p>
            </section>

            <section className="mb-12">
              <div className="flex items-center gap-3 mb-4 text-rose-600">
                <AlertTriangle className="w-6 h-6" />
                <h2 className="text-2xl font-black m-0 tracking-tight">2. NO PROFESSIONAL ADVICE</h2>
              </div>
              <div className="bg-rose-50 border-l-4 border-rose-600 p-6 rounded-r-xl font-bold text-rose-900">
                DevelopmentAnalyzer is an AI-powered preliminary information tool. All reports, analyses, and data provided ARE FOR INFORMATIONAL PURPOSES ONLY and do not constitute architectural, engineering, legal, or professional real estate advice.
              </div>
              <p className="text-slate-600 leading-relaxed mt-4">
                Users are strictly required to verify all AI-generated findings with a licensed professional (Architect, Civil Engineer, or Land Use Attorney) before making financial or development commitments.
              </p>
            </section>

            <section className="mb-12">
              <div className="flex items-center gap-3 mb-4">
                <Zap className="w-5 h-5 text-blue-600" />
                <h2 className="text-xl font-bold text-slate-900 m-0">3. Service Limitations</h2>
              </div>
              <p className="text-slate-600 leading-relaxed">
                Our platform utilizes GIS data from various municipal and state sources. While we strive for absolute precision, DevelopmentAnalyzer does not guarantee the accuracy, completeness, or timeliness of municipal codes, zoning changes, or site constraints.
              </p>
            </section>

            <section className="mb-12">
              <div className="flex items-center gap-3 mb-4">
                <Scale className="w-5 h-5 text-blue-600" />
                <h2 className="text-xl font-bold text-slate-900 m-0">4. Limitation of Liability</h2>
              </div>
              <p className="text-slate-600 leading-relaxed font-semibold text-slate-900">
                TO THE MAXIMUM EXTENT PERMITTED BY LAW, DEVELOPMENTANALYZER SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUES, WHETHER INCURRED DIRECTLY OR INDIRECTLY, RESULTING FROM YOUR RELIANCE ON THE SERVICE.
              </p>
            </section>

            <section className="mb-12">
              <div className="flex items-center gap-3 mb-4">
                <HelpCircle className="w-5 h-5 text-blue-600" />
                <h2 className="text-xl font-bold text-slate-900 m-0">5. User Responsibilities</h2>
              </div>
              <p className="text-slate-600 leading-relaxed">
                As a user, you are responsible for maintaining the confidentiality of your account and for all activities that occur under your precision intelligence reports.
              </p>
            </section>

            <div className="bg-slate-100 p-8 rounded-2xl mt-12 text-center text-slate-500 font-medium">
              By using this platform, you acknowledge that you have read and understood these terms. For legal inquiries, please contact <a href="mailto:legal@privateopenhouse.com" className="text-blue-600 underline">legal@privateopenhouse.com</a>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default TermsOfService;
